<template>
  <layout-main-inner title="监管机构">
    <layout-card-wrap class="el-card-flex">
      <div style="display: flex;">
        <forms ref="forms"
          @emit:task="formTask" />
        <detail v-show="current"
          ref="detail" />
      </div>
    </layout-card-wrap>
  </layout-main-inner>
  <!-- <div class="content-wrapper">
    <div class="content-header">
      <div class="title">监管机构</div>
    </div>
    <el-card shadow="hover"
      style="margin: 0 15px"
      class="el-card-flex">
      <forms ref="forms"
        @emit:task="formTask" />
      <detail v-show="current"
        ref="detail" />
    </el-card>
  </div> -->
</template>
<script>
import Detail from './busi/detail.vue'
import Forms from './busi/form.vue'
export default {
  name: 'supervise-index',
  components: { Forms, Detail },
  data () {
    return {
      current: ''
    }
  },
  methods: {
    formTask (obj) {
      this.current = obj.regulatorId
      this.$nextTick(() => {
        this.$refs.detail.getOrganization(obj)
      })
    }
  }
}
</script>
